import { ComponentChildren } from 'preact';
import { multiVariantStyles } from './themes/SubheadingStyles.css';

export const subheadingElementTypes = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span'] as const;

type ElementType = (typeof subheadingElementTypes)[number];

type SubheadingProps = {
  /**
   * Specifies the subheading tag. When a heading tag should not be used 'as' may be set to div or span, for example in collection group headers (such as list view group headers).
   */
  as: ElementType;

  /**
   * Specifies text color. If set as "inherit", takes text color from its parent element.
   */
  variant?: 'primary' | 'secondary' | 'disabled' | 'inherit';

  /**
   * Specifies the font size and line height.
   */
  size?: '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'inherit';

  /**
   * Specifies the subheader id
   */
  id?: string;

  /**
   * Specifies the children
   */
  children: ComponentChildren;
};

const headingsizeMap = {
  h1: '2xl',
  h2: 'xl',
  h3: 'lg',
  h4: 'md',
  h5: 'sm',
  h6: 'xs',
  div: 'md',
  span: 'md'
};

export const sizeOptions = ['2xs', 'xs', 'sm', 'md', 'lg', 'xl', '2xl', 'inherit'];
/**
 * A Subheading is a title given to a subsection.
 */
export const Subheading = ({ children, as, size, id, variant = 'primary' }: SubheadingProps) => {
  const Component = as;
  //@ts-ignore
  size = size ?? headingsizeMap[Component];
  const classes = multiVariantStyles({ size, variant });
  return (
    <Component className={classes} id={id}>
      {children}
    </Component>
  );
};
